import { render, staticRenderFns } from "./AppointmentsTable.vue?vue&type=template&id=5ee92cf4&scoped=true"
import script from "./AppointmentsTable.vue?vue&type=script&lang=js"
export * from "./AppointmentsTable.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsTable.vue?vue&type=style&index=0&id=5ee92cf4&prod&lang=scss&scoped=true"
import style1 from "./AppointmentsTable.vue?vue&type=style&index=1&id=5ee92cf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee92cf4",
  null
  
)

export default component.exports